import React, { useState, useEffect } from 'react';
import { 
  FaFish, 
  FaHeart, 
  FaStar, 
  FaTrophy, 
  FaAward, 
  FaLeaf, 
  FaShieldAlt, 
  FaUsers, 
  FaGlobe, 
  FaCalendarAlt,
  FaHome,
  FaEnvelope,
  FaUserCircle,
  FaCheckCircle,
  FaQuoteLeft,
  FaQuoteRight,
  FaChartLine,
  FaHandsHelping,
  FaSeedling,
  FaWater,
  FaCrown,
  FaRocket,
  FaEye,
  FaBullhorn
} from 'react-icons/fa';
import { GiFishbone, GiGrowth, GiHealthNormal, GiFishCorpse } from 'react-icons/gi';
import { useNavigate } from 'react-router-dom';
import logo from "./../assests/Untitled design.png"

const AboutUsPage = () => {
  const [isMobile, setIsMobile] = useState(false);
  const [activeTab, setActiveTab] = useState('about');
  const [animate, setAnimate] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const checkScreenSize = () => {
      setIsMobile(window.innerWidth < 768);
    };
    checkScreenSize();
    window.addEventListener('resize', checkScreenSize);
    
    // Trigger animations after load
    setTimeout(() => setAnimate(true), 100);
    
    return () => window.removeEventListener('resize', checkScreenSize);
  }, []);

  // Primary color
  const primaryColor = '#1770b6';

  const stats = [
    { icon: <FaUsers className="text-3xl" />, value: '5000+', label: 'Happy Customers', color: primaryColor },
    // { icon: <FaTrophy className="text-3xl" />, value: '25+', label: 'Awards Won', color: '#f59e0b' },
    { icon: <FaGlobe className="text-3xl" />, value: '15+', label: 'States Served', color: primaryColor },
    { icon: <FaFish className="text-3xl" />, value: '100+', label: 'Fish Species', color: '#10b981' }
  ];

  const values = [
    { icon: <FaLeaf className="text-2xl" />, title: 'Quality First', description: 'Premium ingredients for optimal fish health', color: primaryColor },
    { icon: <FaShieldAlt className="text-2xl" />, title: 'Trust & Transparency', description: 'Honest practices, clear communication', color: primaryColor },
    { icon: <FaHeart className="text-2xl" />, title: 'Customer Care', description: '24/7 support for all your queries', color: '#ef4444' },
    { icon: <FaSeedling className="text-2xl" />, title: 'Sustainability', description: 'Eco-friendly sourcing and packaging', color: '#10b981' }
  ];

  const milestones = [
    { year: '2015', title: 'The Beginning', description: 'Started with a vision to provide premium fish food' },
    { year: '2017', title: 'First Expansion', description: 'Opened manufacturing facility in Chennai' },
    // { year: '2019', title: 'National Recognition', description: 'Awarded Best Fish Food Brand in India' },
    // { year: '2021', title: 'Global Reach', description: 'Expanded to 15+ States worldwide' },
    { year: '2024', title: 'Innovation Hub', description: 'Launched research center for advanced nutrition' }
  ];

  const teamMembers = [
    { name: 'Dr. Rajesh Kumar', role: 'Founder & CEO', image: 'https://randomuser.me/api/portraits/men/1.jpg', bio: 'Marine biologist with 20+ years experience' },
    { name: 'Priya Sharma', role: 'Head of Research', image: 'https://randomuser.me/api/portraits/women/2.jpg', bio: 'PhD in Aquatic Nutrition' },
    { name: 'Arun Venkatesh', role: 'Operations Director', image: 'https://randomuser.me/api/portraits/men/3.jpg', bio: 'Supply chain expert' },
    { name: 'Dr. Meera Iyer', role: 'Quality Control', image: 'https://randomuser.me/api/portraits/women/4.jpg', bio: 'Food safety specialist' }
  ];

  // Mobile Bottom Navigation
  const MobileBottomNav = () => (
    <div className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-100 shadow-lg z-40" style={{ maxWidth: '500px', margin: '0 auto' }}>
      <div className="flex justify-around py-2">
        <button onClick={() => navigate('/')} className="flex flex-col items-center py-1 px-5 rounded-full transition text-gray-400">
          <FaHome className="text-2xl" />
          <span className="text-xs mt-0.5 font-medium">Home</span>
        </button>
        <button onClick={() => navigate('/fish-food')} className="flex flex-col items-center py-1 px-5 rounded-full transition text-gray-400">
          <FaFish className="text-2xl" />
          <span className="text-xs mt-0.5 font-medium">Shop</span>
        </button>
        <button onClick={() => setActiveTab('about')} className="flex flex-col items-center py-1 px-5 rounded-full transition text-[#1770b6]">
          <FaHeart className="text-2xl" />
          <span className="text-xs mt-0.5 font-medium">About</span>
        </button>
        <button onClick={() => navigate('/contact')} className="flex flex-col items-center py-1 px-5 rounded-full transition text-gray-400">
          <FaEnvelope className="text-2xl" />
          <span className="text-xs mt-0.5 font-medium">Contact</span>
        </button>
        <button onClick={() => navigate('/profile')} className="flex flex-col items-center py-1 px-5 rounded-full transition text-gray-400">
          <FaUserCircle className="text-2xl" />
          <span className="text-xs mt-0.5 font-medium">Profile</span>
        </button>
      </div>
    </div>
  );

  // Mobile View
  const MobileView = () => (
    <div className="max-w-md mx-auto bg-gray-50 min-h-screen relative pb-24">
      {/* Hero Section */}
      <div className="relative bg-gradient-to-br from-[#1770b6] to-[#0e5a94] pt-12 pb-12 px-5 rounded-b-3xl overflow-hidden">
        <div className="absolute inset-0 bg-black/20"></div>
        <div className="relative z-10 text-center">
          <div className="w-20 h-20 bg-white/100 rounded-full flex items-center justify-center mx-auto mb-4">
             <img src={logo} className='h-18 w-auto' alt='logo'/>
          </div>
          <h1 className="text-3xl font-bold text-white mb-2">About Lion Head</h1>
          <p className="text-white/90 text-sm">Premium Fish Food Since 2015</p>
        </div>
      </div>

      {/* Our Story */}
      <div className="px-4 -mt-6 mb-6">
        <div className="bg-white rounded-2xl p-5 shadow-sm">
          <div className="flex items-center gap-2 mb-3">
            <FaQuoteLeft className="text-[#1770b6] text-lg" />
            <h2 className="text-lg font-bold text-gray-800">Our Story</h2>
          </div>
          <p className="text-gray-600 text-sm leading-relaxed mb-3">
                        With a legacy spanning over 20 years, Sun Swathi Aqua Farm stands as a pioneer in aquaculture. Building upon this foundation of expertise, Lion Head was founded in 2020 with a simple mission: to provide premium, scientifically-formulated fish food that promotes vibrant colors, healthy growth, and optimal nutrition.

          </p>
          <p className="text-gray-600 text-sm leading-relaxed">
           What began as a passion project in a Chennai laboratory—backed by decades of hands-on farm experience—has grown into India's most trusted fish food brand, serving over 5000 happy customers . Every formula is developed in collaboration with aquatic nutritionists and tested rigorously to ensure the highest quality standards. <br/>
           we plan expanded other state

          </p>
        </div>
      </div>

      {/* Mission & Vision */}
      <div className="px-4 mb-6">
        <div className="grid grid-cols-1 gap-3">
          <div className="bg-gradient-to-r from-[#1770b6]/10 to-transparent rounded-2xl p-4 border-l-4 border-[#1770b6]">
            <div className="flex items-center gap-2 mb-2">
              <FaRocket className="text-[#1770b6] text-lg" />
              <h3 className="font-bold text-gray-800">Our Mission</h3>
            </div>
            <p className="text-gray-600 text-sm">To deliver premium quality fish nutrition that ensures healthy, vibrant fish for every aquarium enthusiast.</p>
          </div>
          <div className="bg-gradient-to-r from-[#1770b6]/10 to-transparent rounded-2xl p-4 border-l-4 border-[#1770b6]">
            <div className="flex items-center gap-2 mb-2">
              <FaEye className="text-[#1770b6] text-lg" />
              <h3 className="font-bold text-gray-800">Our Vision</h3>
            </div>
            <p className="text-gray-600 text-sm">To become the world's most trusted fish food brand, setting new standards in aquatic nutrition.</p>
          </div>
        </div>
      </div>

      {/* Stats */}
      <div className="px-4 mb-6">
        <div className="grid grid-cols-2 gap-3">
          {stats.map((stat, index) => (
            <div key={index} className="bg-white rounded-2xl p-4 text-center shadow-sm">
              <div className="flex justify-center mb-2" style={{ color: stat.color }}>{stat.icon}</div>
              <div className="text-xl font-bold text-gray-800">{stat.value}</div>
              <div className="text-xs text-gray-500">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>

      {/* Our Values */}
      <div className="px-4 mb-6">
        <h2 className="text-lg font-bold text-gray-800 mb-3 text-center">Our Values</h2>
        <div className="grid grid-cols-2 gap-3">
          {values.map((value, index) => (
            <div key={index} className="bg-white rounded-2xl p-4 text-center shadow-sm">
              <div className="flex justify-center mb-2" style={{ color: value.color }}>{value.icon}</div>
              <h3 className="font-semibold text-gray-800 text-sm">{value.title}</h3>
              <p className="text-gray-500 text-xs mt-1">{value.description}</p>
            </div>
          ))}
        </div>
      </div>

      {/* Journey Timeline */}
      <div className="px-4 mb-6">
        <h2 className="text-lg font-bold text-gray-800 mb-3 text-center">Our Journey</h2>
        <div className="relative">
          {milestones.map((milestone, index) => (
            <div key={index} className="flex mb-4 last:mb-0">
              <div className="flex flex-col items-center mr-3">
                <div className="w-8 h-8 bg-[#1770b6] rounded-full flex items-center justify-center">
                  <span className="text-white text-xs font-bold">{milestone.year.slice(-2)}</span>
                </div>
                {index < milestones.length - 1 && <div className="w-0.5 h-full bg-gray-200 mt-1"></div>}
              </div>
              <div className="flex-1 bg-white rounded-xl p-3 shadow-sm mb-2">
                <h3 className="font-semibold text-gray-800 text-sm">{milestone.title}</h3>
                <p className="text-gray-500 text-xs mt-1">{milestone.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Why Choose Us */}
      <div className="px-4 mb-6">
        <div className="bg-gradient-to-r from-[#1770b6] to-[#0e5a94] rounded-2xl p-5 text-center text-white">
          <FaCrown className="text-3xl mx-auto mb-2 text-yellow-400" />
          <h2 className="text-lg font-bold mb-2">Why Choose Lion Head?</h2>
          <p className="text-white/90 text-sm mb-3">Premium quality • Scientifically formulated • Trusted by thousands</p>
          <div className="flex justify-center gap-4 text-xs">
            <span className="flex items-center gap-1"><FaCheckCircle className="text-green-400" /> Natural Ingredients</span>
            <span className="flex items-center gap-1"><FaCheckCircle className="text-green-400" /> Lab Tested</span>
          </div>
        </div>
      </div>

      {/* Bottom Navigation */}
      <MobileBottomNav />
    </div>
  );

  // Desktop View
  const DesktopView = () => (
    <div className="min-h-screen bg-gray-50">
      {/* Hero Section */}
      <div className="relative bg-gradient-to-r from-[#1770b6] to-[#0e5a94] overflow-hidden">
        <div className="absolute inset-0 bg-black/20"></div>
        <div className="relative max-w-7xl mx-auto px-6 py-20">
          <div className="text-center">
            <div className="inline-flex items-center gap-2 bg-white/20 backdrop-blur rounded-full px-4 py-2 mb-6">
              <FaFish className="text-white" />
              <span className="text-sm text-white">Since 2015</span>
            </div>
            <h1 className="text-5xl font-bold text-white mb-4">About Lion Head</h1>
            <p className="text-white/90 text-lg max-w-2xl mx-auto">
              Premium fish food crafted with science and passion for vibrant, healthy fish
            </p>
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div className="max-w-7xl mx-auto px-6 py-12">
        {/* Our Story */}
        <div className="grid lg:grid-cols-2 gap-12 items-center mb-16">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <FaQuoteLeft className="text-[#1770b6] text-2xl" />
              <span className="text-[#1770b6] font-semibold">Our Story</span>
            </div>
            <h2 className="text-3xl font-bold text-gray-800 mb-4">The Lion Head Legacy</h2>
            <p className="text-gray-600 leading-relaxed mb-4">
                            With a legacy spanning over 20 years, Sun Swathi Aqua Farm stands as a pioneer in aquaculture. Building upon this foundation of expertise, Lion Head was founded in 2020 with a simple mission: to provide premium, scientifically-formulated fish food that promotes vibrant colors, healthy growth, and optimal nutrition.

            </p>
            <p className="text-gray-600 leading-relaxed mb-6">

What began as a passion project in a Chennai laboratory—backed by decades of hands-on farm experience—has grown into India's most trusted fish food brand, serving over 5000 happy customers . Every formula is developed in collaboration with aquatic nutritionists and tested rigorously to ensure the highest quality standards. We Planed to Expland Our Business To Other state Also
            </p>
            <div className="flex gap-4">
              <div className="flex items-center gap-2">
                <FaCheckCircle className="text-[#1770b6]" />
                <span className="text-sm text-gray-600">100% Natural</span>
              </div>
              <div className="flex items-center gap-2">
                <FaCheckCircle className="text-[#1770b6]" />
                <span className="text-sm text-gray-600">Lab Tested</span>
              </div>
              <div className="flex items-center gap-2">
                <FaCheckCircle className="text-[#1770b6]" />
                <span className="text-sm text-gray-600">Vet Approved</span>
              </div>
            </div>
          </div>
          <div className="relative">
            <div className="absolute -inset-4 bg-[#1770b6]/20 rounded-3xl blur-2xl"></div>
            <div className="relative bg-gradient-to-br from-[#1770b6] to-[#0e5a94] rounded-3xl p-8 text-white text-center">
              <FaFish className="text-6xl mx-auto mb-4" />
              <p className="text-lg font-semibold">"Quality nutrition for healthier fish"</p>
              {/* <p className="text-white/80 text-sm mt-2">- Dr. Rajesh Kumar, Founder</p> */}
            </div>
          </div>
        </div>

        {/* Stats Section */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-16">
          {stats.map((stat, index) => (
            <div key={index} className="bg-white rounded-2xl p-6 text-center shadow-sm hover:shadow-md transition-all hover:-translate-y-1">
              <div className="flex justify-center mb-3" style={{ color: stat.color }}>{stat.icon}</div>
              <div className="text-2xl font-bold text-gray-800">{stat.value}</div>
              <div className="text-gray-500 text-sm">{stat.label}</div>
            </div>
          ))}
        </div>

        {/* Mission & Vision */}
        <div className="grid lg:grid-cols-2 gap-6 mb-16">
          <div className="bg-gradient-to-r from-[#1770b6]/5 to-transparent rounded-2xl p-6 border-l-4 border-[#1770b6]">
            <div className="flex items-center gap-3 mb-3">
              <FaRocket className="text-[#1770b6] text-2xl" />
              <h3 className="text-xl font-bold text-gray-800">Our Mission</h3>
            </div>
            <p className="text-gray-600 leading-relaxed">
              To deliver premium quality fish nutrition that ensures healthy, vibrant fish while 
              promoting sustainable aquaculture practices worldwide.
            </p>
          </div>
          <div className="bg-gradient-to-r from-[#1770b6]/5 to-transparent rounded-2xl p-6 border-l-4 border-[#1770b6]">
            <div className="flex items-center gap-3 mb-3">
              <FaEye className="text-[#1770b6] text-2xl" />
              <h3 className="text-xl font-bold text-gray-800">Our Vision</h3>
            </div>
            <p className="text-gray-600 leading-relaxed">
              To become the world's most trusted fish food brand, setting new standards in 
              aquatic nutrition and sustainability.
            </p>
          </div>
        </div>

        {/* Values */}
        <div className="mb-16">
          <h2 className="text-3xl font-bold text-gray-800 text-center mb-3">Our Core Values</h2>
          <p className="text-gray-500 text-center mb-8">What drives us every day</p>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            {values.map((value, index) => (
              <div key={index} className="bg-white rounded-2xl p-6 text-center shadow-sm hover:shadow-md transition-all hover:-translate-y-1">
                <div className="flex justify-center mb-3" style={{ color: value.color }}>{value.icon}</div>
                <h3 className="font-semibold text-gray-800 text-lg mb-2">{value.title}</h3>
                <p className="text-gray-500 text-sm">{value.description}</p>
              </div>
            ))}
          </div>
        </div>

        {/* Journey Timeline */}
        <div className="mb-16">
          <h2 className="text-3xl font-bold text-gray-800 text-center mb-3">Our Journey</h2>
          <p className="text-gray-500 text-center mb-8">Milestones that shaped us</p>
          <div className="relative">
            <div className="absolute left-1/2 transform -translate-x-1/2 w-0.5 h-full bg-[#1770b6]/30 hidden lg:block"></div>
            <div className="space-y-8">
              {milestones.map((milestone, index) => (
                <div key={index} className={`flex flex-col lg:flex-row ${index % 2 === 0 ? 'lg:flex-row' : 'lg:flex-row-reverse'} items-center gap-6`}>
                  <div className="flex-1">
                    <div className={`bg-white rounded-2xl p-6 shadow-sm hover:shadow-md transition-all ${index % 2 === 0 ? 'lg:text-right' : ''}`}>
                      <h3 className="text-xl font-bold text-gray-800">{milestone.title}</h3>
                      <p className="text-gray-500 mt-2">{milestone.description}</p>
                    </div>
                  </div>
                  <div className="relative z-10">
                    <div className="w-12 h-12 bg-[#1770b6] rounded-full flex items-center justify-center shadow-lg">
                      <span className="text-white font-bold text-sm">{milestone.year.slice(-2)}</span>
                    </div>
                  </div>
                  <div className="flex-1 hidden lg:block"></div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Why Choose Us */}
        <div className="bg-gradient-to-r from-[#1770b6] to-[#0e5a94] rounded-3xl p-8 text-center text-white">
          <FaCrown className="text-5xl mx-auto mb-4 text-yellow-400" />
          <h2 className="text-3xl font-bold mb-4">Why Choose Lion Head?</h2>
          <p className="text-white/90 text-lg mb-6 max-w-2xl mx-auto">
            Premium quality fish food trusted by thousands of aquarium enthusiasts worldwide
          </p>
          <div className="flex flex-wrap justify-center gap-6">
            <div className="flex items-center gap-2"><FaCheckCircle className="text-green-400" /> 100% Natural Ingredients</div>
            <div className="flex items-center gap-2"><FaCheckCircle className="text-green-400" /> Scientifically Formulated</div>
            <div className="flex items-center gap-2"><FaCheckCircle className="text-green-400" /> Lab Tested for Quality</div>
            <div className="flex items-center gap-2"><FaCheckCircle className="text-green-400" /> 24/7 Customer Support</div>
          </div>
        </div>
      </div>
    </div>
  );

  return isMobile ? <MobileView /> : <DesktopView />;
};

export default AboutUsPage;